import React, { useState } from 'react';
import api from '../../../utils/api';

const Security = ({ user }) => {
  const [manualMode, setManualMode] = useState(false);
  const [password, setPassword] = useState('');

  const handleManualPassword = async () => {
    if (!password) return alert('Debe ingresar una contraseña');
    try {
      await api.put(`/api/users/password/${user.id}`, { newPassword: password });
      alert('Contraseña actualizada correctamente');
      setManualMode(false);
      setPassword('');
    } catch (err) {
      console.error(err);
      alert('Error al actualizar la contraseña');
    }
  };

  return (
    <div className="space-y-10">
      <div>
        <h3 className="text-lg font-semibold text-blue-800 mb-4">Inicio de sesión</h3>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-700">Permitir inicio de sesión</span>
          <input
            type="checkbox"
            className="form-toggle h-5 w-10 rounded-full bg-gray-300 checked:bg-blue-600 transition-all"
            defaultChecked
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-blue-800 mb-4">Seguridad</h3>
        <p className="text-sm text-gray-700">
          Para enviar instrucciones de restablecimiento de contraseña a{' '}
          <strong className="text-gray-900">{user.email}</strong>,{' '}
          <a href="#" className="text-blue-700 hover:underline">haga clic aquí</a>.
        </p>
        <p className="text-sm text-gray-700 mt-2">
          Alternativamente,{' '}
          <button
            type="button"
            onClick={() => setManualMode(true)}
            className="text-blue-700 hover:underline"
          >
            haga clic aquí
          </button>{' '}
          para establecer manualmente una nueva contraseña para este cliente.
        </p>

        {manualMode && (
          <div className="mt-4 space-y-2">
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border rounded px-3 py-2"
            />
            <button
              onClick={handleManualPassword}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Cambiar Contraseña
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Security;
